export type StatisticsPeriod = 'day' | 'last7' | 'last30' | 'currentMonth' | 'previousMonth'

export const statisticsPeriodOptions: Array<{ key: StatisticsPeriod, label: string }> = [
  { key: 'day', label: '昨日' },
  { key: 'last7', label: '最近7天' },
  { key: 'last30', label: '最近30天' },
  { key: 'currentMonth', label: '本月' },
  { key: 'previousMonth', label: '上月' },
]

const dateFromString = (value: string) => new Date(`${value}T00:00:00Z`)
const dateToString = (value: Date) => value.toISOString().slice(0, 10)
const shiftDate = (value: string, days: number) => {
  const date = dateFromString(value)
  date.setUTCDate(date.getUTCDate() + days)
  return dateToString(date)
}

export function statisticsWindow(period: StatisticsPeriod, selectedDate: string, availableDates: string[]) {
  let startDate = selectedDate
  let endDate = selectedDate
  if (period === 'last7') startDate = shiftDate(selectedDate, -6)
  if (period === 'last30') startDate = shiftDate(selectedDate, -29)
  if (period === 'currentMonth') startDate = `${selectedDate.slice(0, 7)}-01`
  if (period === 'previousMonth') {
    const currentMonthStart = dateFromString(`${selectedDate.slice(0, 7)}-01`)
    const previousMonthEnd = new Date(currentMonthStart)
    previousMonthEnd.setUTCDate(0)
    const previousMonthStart = new Date(Date.UTC(previousMonthEnd.getUTCFullYear(), previousMonthEnd.getUTCMonth(), 1))
    startDate = dateToString(previousMonthStart)
    endDate = dateToString(previousMonthEnd)
  }
  const dates = availableDates.filter((date) => date >= startDate && date <= endDate)
  const requestedDayCount = Math.round((dateFromString(endDate).getTime() - dateFromString(startDate).getTime()) / 86400000) + 1
  return {
    key: period,
    label: statisticsPeriodOptions.find((item) => item.key === period)?.label || '昨日',
    startDate,
    endDate,
    dates,
    requestedDayCount,
    complete: dates.length === requestedDayCount,
  }
}

export const visibleDateRange = (dates: string[]) => {
  if (!dates.length) return '暂无可用数据'
  if (dates.length === 1) return dates[0]
  return `${dates[0]} 至 ${dates[dates.length - 1]}`
}
